import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, axiosInstance } from 'lib';


export const getBannerlist = createAsyncThunk(
    'Get Banner',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.BANNNER_LIST, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);